// extracted by mini-css-extract-plugin
export default {"input":"search-input_input__K-u2p"};